import { render, staticRenderFns } from "./ScheduledReparationDateQuestion.vue?vue&type=template&id=47efb3ca&scoped=true"
import script from "./ScheduledReparationDateQuestion.vue?vue&type=script&lang=ts"
export * from "./ScheduledReparationDateQuestion.vue?vue&type=script&lang=ts"
import style0 from "./ScheduledReparationDateQuestion.vue?vue&type=style&index=0&id=47efb3ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47efb3ca",
  null
  
)

export default component.exports